// extracted by mini-css-extract-plugin
export default {"root":"FileItem_root__nUR3+","file":"FileItem_file__JqErC","iconFile":"FileItem_iconFile__q8dGL","expired":"FileItem_expired__741q1","iconClose":"FileItem_iconClose__HrVA0"};